import React, { useContext, useState } from "react";
import {
  Stack,
  IconButton,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import DoDisturbOnOutlinedIcon from "@mui/icons-material/DoDisturbOnOutlined";
import CircularProgress from "@mui/material/CircularProgress";
//Srcs
import { AuthContext } from "../Context/AuthContext";
import Auth from "../Auth";

import { LOG_OUT } from "../Schema/User";
import { useMutation } from "@apollo/client";

export default function LogoutMenu({ open, handleClose }) {
  const [iconReload, setIconReload] = useState(false);
  const { setAlert } = useContext(AuthContext);

  const [logOut] = useMutation(LOG_OUT, {
    onCompleted: ({ logOut }) => {
      setIconReload(false);
      if (logOut?.status) {
        setAlert(true, "success", logOut?.message);
        handleClose();
        window.localStorage.clear();
        window.location.reload("/login");
      } else {
        setAlert(true, "error", logOut?.message);
      }
    },
    onError: (error) => {
      setIconReload(false);
      setAlert(true, "error", error?.message);
    },
  });

  const handleLogOut = () => {
    setIconReload(true) 
    setTimeout( () => {
      setAlert(true, "success", "Logout Success!");
      handleClose();
      window.localStorage.clear();
      window.location.reload("/login");
    },1000) 
    logOut(); 
  }

  return (
    <Dialog open={open}>
      <DialogTitle>
        <Stack
          direction="row"
          justifyContent="right"
          sx={{ marginTop: "-5px" }}
        >
          <IconButton onClick={handleClose}>
            <DoDisturbOnOutlinedIcon sx={{ color: "red", fontSize: "25px" }} />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack direction="column" justifyContent="center" height="150px">
          <Stack
            direction="row"
            justifyContent="center"
            width="400px"
            marginTop="-10px"
          >
            <Typography
              sx={{
                fontWeight: "bold",
                color: "black",
                fontSize: "20px",
              }}
            >
              {/* You are attemping to log out. */}
              លោកអ្នកកំពុងតែព្យាយាមចាកចេញ
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="center" width="400px">
            <Typography sx={{ color: "black", fontSize: "15px" }}>
              {/* Are you sure? */}
              តើមែនដែរឬទេ?
            </Typography>
          </Stack>

          <Stack
            direction="row"
            justifyContent="center"
            width="400px"
            marginTop="30px"
          >
            <Button
              onClick={handleLogOut}
              autoFocus
              fullWidth
              sx={{
                backgroundColor: "#f75257",
                color: "white",
                ":hover": {
                  backgroundColor: "#f75257",
                },
                fontFamily: "Kantumruy Pro",
              }}
              endIcon={
                iconReload ? (
                  <CircularProgress sx={{ color: "#fff" }} size="20px" />
                ) : null
              }
            >
              <Typography className="log-out-txt">ចាកចេញ</Typography>
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
